import { useSelector } from "react-redux"
import styled from "styled-components"
import UpdateBlogMenus from "./updateBlog/UpdateBlogMenus"
import NewBlogMainSide from "./newBlog/NewBlogMainSide"

const Container = styled.div`
    width: calc(100% - 290px);
    height: 100%;
    border-radius: 10px;
    border: 1px solid ${({theme}) => theme.mainBorderColor};
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
    overflow: auto;
`


const BlogContentSide = () => {
    const {selectedBlog} = useSelector((state) => state.admin3)
  
  return (

    <Container>

        {selectedBlog ? 
            <UpdateBlogMenus />
            :
            <NewBlogMainSide />
        }
         
    </Container>
  )
}

export default BlogContentSide